import { Layout } from '@/components/Layout';
import { LookupTable } from '../components/LookupTable';
import { lookupsApi } from '../api';

export default function StatusPage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <LookupTable
          title="Estados"
          description="Gestiona los estados de adopción"
          queryKey="status"
          listFn={lookupsApi.listStatus}
          createFn={lookupsApi.createStatus}
          updateFn={lookupsApi.updateStatus}
          deleteFn={lookupsApi.deleteStatus}
        />
      </div>
    </Layout>
  );
}
